module.exports = __webpack_public_path__ + "static/img/首页入口2025.4d35712.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/首页入口2025.gif
// module id = GYls
// module chunks = 3